import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/AudiusLogo.svg'

export const IconAudiusLogo = IconSVG as IconComponent
